module.exports = __webpack_public_path__ + "static/media/cookie_filled.9101805f.svg";